module.exports = __webpack_public_path__ + "16921e4f4c2f6beff464634721289b43.jpg";